module.exports = __webpack_public_path__ + "static/img/logo2.df28d037.png";